import { useGetCountiesQuery } from '@api/api';

export function useGetCountyById() {
  const { data } = useGetCountiesQuery();
  return (id: number) => {
    let returnCounty = undefined as boolean | any;
    if (data?.data) {
      data.data.forEach((county: any) => {
        if (county.id == id) {
          returnCounty = county.name;
        }
      });
    }
    return returnCounty;
  };
}
